import useVisibleSprite from './useVisibleSprite';

export default function BuffyStatusSprite({ state, className = '' }) {
  const [ref, visible] = useVisibleSprite();
  return <span ref={ref} className={`buffy-status${className ? ` ${className}` : ''}`} data-state={state} data-paused={!visible} aria-hidden="true" />;
}
